import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, Box } from '@mui/material';
import { ThemeContextProvider } from './theme/ThemeContext';
import { AuthProvider } from './utils/AuthContext';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import CourseDetails from './pages/CourseDetails';
import Certifications from './pages/Certifications';
import Careers from './pages/Careers';
import Blog from './pages/Blog';
import Dashboard from './pages/Dashboard';
import Checkout from './pages/Checkout';
import Contact from './pages/Contact';
import Enterprise from './pages/Enterprise';
import CourseSelection from './pages/CourseSelection';
import QuizPage from './pages/QuizPage';

// KaaS Module
import Kaasdev from './KaaS/src/Kaasdev';
import GatePdev from './GateP/src/gatePdev';



function App() {
  const [isQuizActive, setIsQuizActive] = React.useState(false);

  return (
    <AuthProvider>
      <ThemeContextProvider>
        <CssBaseline />
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <ScrollToTop />
          <Routes>
            {/* Redirect root to /db-shiksha */}
            <Route path="/" element={<Navigate to="/db-shiksha" replace />} />

            {/* KaaS LMS – rendered without DB-Shiksha Navbar/Footer */}
            {/* KaaS Module – separate admin and student routes */}
            <Route path="/db-shiksha/kaas/admin/*" element={<Kaasdev />} />
            <Route path="/db-shiksha/kaas/student/*" element={<Kaasdev />} />
            <Route path="/db-shiksha/kaas/*" element={<Kaasdev />} />

            {/* GateP Module - Unified route handler */}
            <Route path="/db-shiksha/gatep/*" element={<GatePdev />} />



            {/* DB-Shiksha public pages – prefixed with /db-shiksha */}
            <Route path="/db-shiksha/*" element={
              <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
                <Navbar isQuizActive={isQuizActive} />
                <Box component="main" sx={{ flexGrow: 1 }}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="about" element={<About />} />
                    <Route path="programs" element={<Programs />} />
                    <Route path="course/:id" element={<CourseDetails />} />
                    <Route path="certifications" element={<Certifications />} />
                    <Route path="careers" element={<Careers />} />
                    <Route path="blog" element={<Blog />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="select-course" element={<CourseSelection />} />
                    <Route path="checkout" element={<Checkout />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="enterprise" element={<Enterprise />} />
                    <Route path="quiz" element={<QuizPage setIsQuizActive={setIsQuizActive} />} />
                    <Route path="*" element={<Home />} />
                  </Routes>
                </Box>
                <Footer />
              </Box>
            } />
          </Routes>
        </Router>
      </ThemeContextProvider>
    </AuthProvider>
  );
}

export default App;
console.log("Home updated");
